import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

import { TranslateService } from '@ngx-translate/core'
import { MessageService } from '../../services/message.service'
import { SiteService } from '../../services/site.service'
import { CustomerChangeRequestTypes } from '../../enumeration'
import { SessionTimeoutModalComponent } from '../modals/session-timeout-modal/session-timeout-modal.component'


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit 
{
  loginSessionExpiredSubscription: Subscription
  preferredLanguageChangedSubscription!: Subscription

  constructor(
    private router: Router,
    public dialog: MatDialog,
		public translateService: TranslateService,
    private siteService: SiteService,
    private messageService: MessageService
	)
  {
    this.loginSessionExpiredSubscription = this.messageService.loginSessionExpired$.subscribe(() =>
    {
        const dialogConfig = new MatDialogConfig()
        dialogConfig.width = '500px'
        const dialogRef =this.dialog.open(SessionTimeoutModalComponent, dialogConfig)
    }) 		
  }

  ngOnInit() 
  {
    this.translateService.use(this.translateService.defaultLang)
    document.querySelector('html')?.setAttribute('lang', this.translateService.defaultLang);
  }

  changeLanguage(lang: string)
  {
    this.translateService.defaultLang = lang
    this.translateService.use(lang)
    document.querySelector('html')?.setAttribute('lang', lang);

    this.messageService.preferredLanguageChanged()
    
    //this.siteService.killChat()
  }

  handleRequestStatus()
  {
    this.router.navigate(['/request-status'])
  }

  handleRequestList()
  {
    this.router.navigate(['/request-list'])
  }

  // handleRequestAddressChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.AddressChange
  //   this.router.navigate(['/address-change'])
  // }

  // handleRequestBankAccountChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.BankAccountChange
  //   this.router.navigate(['/bank-account-change'])
  // }

  // handleRequestEmailChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.EmailChange
  //   this.router.navigate(['/email-change'])
  // }

  // handleRequestLeaseTransfer()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.LeaseTransfer
  //   this.router.navigate(['/lease-transfer'])
  // }

  // handleRequestNameChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.NameChange
  //   this.router.navigate(['/name-change'])
  // }

  // handleRequestOtherChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.OtherRequest
  //   this.router.navigate(['/other-change'])
  // }

  // handleRequestPaymentDateChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.PaymentDateChange
  //   this.router.navigate(['/payment-date-change'])
  // }

  // handleRequestPhoneChange()
  // {
  //   this.siteService.customerRequestType = CustomerChangeRequestTypes.PhoneChange
  //   this.router.navigate(['/phone-change'])
  // }

}
